/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_ViewInputs */

const th_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด`)
};

const en_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const ja_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

const zh_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开`)
};

const es_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const pt_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const id_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const fr_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const tl_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan`)
};

const vi_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở`)
};

const ko_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열기`)
};

const de_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen`)
};

const ru_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const tr_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aç`)
};

const it_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

const pl_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz`)
};

const uk_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити`)
};

const hi_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलें`)
};

const ar_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const ms_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const bn_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খুলুন`)
};

const zh_tw2_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

const zh_hk2_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

const ur_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھولیں`)
};

const fa_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باز کردن`)
};

const sw_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua`)
};

const nl_org_view = /** @type {(inputs: Org_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Org_ViewInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_view = /** @type {((inputs?: Org_ViewInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_ViewInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_view(inputs)
	if (locale === "ja") return ja_org_view(inputs)
	if (locale === "zh") return zh_org_view(inputs)
	if (locale === "es") return es_org_view(inputs)
	if (locale === "pt") return pt_org_view(inputs)
	if (locale === "id") return id_org_view(inputs)
	if (locale === "fr") return fr_org_view(inputs)
	if (locale === "tl") return tl_org_view(inputs)
	if (locale === "vi") return vi_org_view(inputs)
	if (locale === "ko") return ko_org_view(inputs)
	if (locale === "de") return de_org_view(inputs)
	if (locale === "ru") return ru_org_view(inputs)
	if (locale === "tr") return tr_org_view(inputs)
	if (locale === "it") return it_org_view(inputs)
	if (locale === "pl") return pl_org_view(inputs)
	if (locale === "uk") return uk_org_view(inputs)
	if (locale === "hi") return hi_org_view(inputs)
	if (locale === "ar") return ar_org_view(inputs)
	if (locale === "ms") return ms_org_view(inputs)
	if (locale === "bn") return bn_org_view(inputs)
	if (locale === "zh-TW") return zh_tw2_org_view(inputs)
	if (locale === "zh-HK") return zh_hk2_org_view(inputs)
	if (locale === "ur") return ur_org_view(inputs)
	if (locale === "fa") return fa_org_view(inputs)
	if (locale === "sw") return sw_org_view(inputs)
	if (locale === "nl") return nl_org_view(inputs)
	return en_org_view(inputs)
});